import * as React from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useNavigate } from 'react-router-dom';

interface NavTabsProps {
  id: string;
  case: number;
  nome?: string
}

export default function NavTabsUsuarios({ id, case: initialCase = 0, nome }: NavTabsProps) {

  const [value, setValue] = React.useState(initialCase);
  const navigate = useNavigate();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);

    // Aqui você pode adicionar lógica para redirecionar com base no valor da guia
    switch (newValue) {
    case 0:
      navigate(`/usuarios/${id}`);
      break;
    case 1:
      navigate(`/usuarios/permissoes/${id}/${nome}`);
      break;
    default:
      break;
    }
  }; 
  
  return (
    <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label="Usuário" />
        <Tab label="Permissões" />
      </Tabs>
    </Box>
  );
}
